<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const prompts = [
  "Write a letter to your friend inviting him to spend summer vacation with you.",
  "Write a letter to your father asking for more pocket money.",
  "Write a letter to the editor about load shedding.",
  "Write a letter to the editor about water shortage in your area.",
  "Write a letter to your friend congratulating him on his success.",
  "Write a letter to your mother about your hostel life.",
];

const formatTips = [
  "Friend letter me friendly tone rakho, editor letter me formal tone.",
  "Opening aur closing relation ke mutabiq choose karo.",
  "Main purpose first paragraph me clear kar dena chahiye.",
  "Editor letter me issue, effect aur suggestion teenon mention karo.",
];

const commonClosings = [
  "Yours sincerely",
  "Yours affectionately",
  "Yours faithfully",
];

const usefulOpenings = [
  "I am fine here and hope that you will also be fine.",
  "I am writing this letter to draw your attention to an important public issue.",
  "I was pleased to hear about your brilliant success in the examination.",
];

const editorChecklist = [
  "Issue ko one-line introduction me define karo.",
  "Do ya teen practical effects batao.",
  "Authorities ya public ke liye one clear suggestion do.",
  "Tone respectful aur formal rakho.",
];

const commonMistakes = [
  "Editor letter me friendly tone use karna ghalat hota hai.",
  "Date ya address skip kar dena format ko weak karta hai.",
  "Body me irrelevant detail add karna marks ko reduce kar sakta hai.",
  "Friend letter me over-formal language use karne se natural flow kharab hota hai.",
];

const sampleLetter = [
  "Examination Hall,",
  "City A.B.C.",
  "June 10, 2026.",
  "My dear Friend,",
  "I am fine here and hope that you will also be fine. I invite you to spend your summer vacation with me. We shall study together and also visit some beautiful places.",
  "Please inform me about your arrival.",
  "Yours sincerely,",
  "Ali",
];

usePageSeo({
  title: "11th Class English Letters | Formal and Informal Letter Writing",
  description: "11th class English letters page with formal and informal letter format, common prompts, editor letter checklist and sample letter.",
  keywords: "11th class english letters, class 11 letter writing, informal letter, formal letter, letter to editor, english grammar letters",
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Grammar", item: "/11th/english/grammar/" },
    { name: "Letters", item: "/11th/english/grammar/letters/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="Grammar Task"
      title="Letters"
      description="Yeh page board paper ke letter-writing section ko direct target karta hai. Is me personal aur formal letter dono ke liye basic revision support hai."
    />

    <EnglishSection title="Common Letter Prompts" description="These are the common prompt types students should rehearse.">
      <EnglishGrid>
        <EnglishCard v-for="item in prompts" :key="item" title="Prompt" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Format Tips" description="Use these rules to keep the tone and structure correct.">
      <EnglishGrid>
        <EnglishCard v-for="item in formatTips" :key="item" title="Format Tip" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Useful Openings" description="These are helpful starting lines for common letter types.">
      <EnglishGrid>
        <EnglishCard v-for="item in usefulOpenings" :key="item" title="Opening" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Common Closings" description="Pick the closing line that matches the relation and tone.">
      <EnglishGrid>
        <EnglishCard v-for="item in commonClosings" :key="item" title="Closing" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Editor Letter Checklist" description="Use this when the prompt asks for a formal issue-based letter to the editor.">
      <EnglishGrid>
        <EnglishCard v-for="item in editorChecklist" :key="item" title="Checklist" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Mini Sample Letter" description="A compact sample showing the overall letter flow.">
      <EnglishLinkList :links="sampleLetter.map((line) => ({ label: line }))" />
    </EnglishSection>

    <EnglishSection title="Common Mistakes" description="Avoid these if you want the response to stay natural and exam-safe.">
      <EnglishGrid>
        <EnglishCard v-for="item in commonMistakes" :key="item" title="Mistake" :description="item" />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
